import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import Vehicles from "@/pages/Vehicles";
import Maintenance from "@/pages/Maintenance";
//import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AuthMagic from "@/pages/AuthMagic";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ThemeProvider, useTheme } from "@/lib/theme";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/ErrorBoundary";

/**
 * Root route. Logged-in users are sent straight to the console; everyone
 * else sees the public marketing landing page.
 */
function HomeRoute() {
  const { user, loading } = useAuth();
  if (loading) return null; // tiny FOUC ok — landing is light, no flash needed
  if (user) return <Navigate to="/dashboard" replace />;
//  return <Landing />;
  return <Login />;
}

function AppRouter() {
  const location = useLocation();
  // Synchronous fragment check — must run before ProtectedRoute checks /auth/me
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomeRoute />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/magic" element={<AuthMagic />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/vehicles"
        element={
          <ProtectedRoute>
            <Vehicles />
          </ProtectedRoute>
        }
      />
      <Route
        path="/maintenance"
        element={
          <ProtectedRoute>
            <Maintenance />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function ThemedToaster() {
  const { resolvedTheme } = useTheme();
  return <Toaster theme={resolvedTheme} position="bottom-right" />;
}

function App() {
  return (
    <div className="App bg-grain">
      <ErrorBoundary scope="app-root">
        <ThemeProvider>
          <BrowserRouter>
            <AuthProvider>
              <AppRouter />
            </AuthProvider>
          </BrowserRouter>
          <ThemedToaster />
        </ThemeProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
